import { TripDesignerWizard } from '@koob/ui/src/features/tripWizard/TripDesignerWizard';
import type { EntryChoice } from '@koob/ui/src/features/tripWizard/types';
import { useDesignTripForm } from '../../hooks/useDesignTripForm';
import type { seedFromComposition } from '../../logic/designTrip';

export interface DesignTripWizardProps {
  mode?: 'create' | 'edit';
  editId?: string;
  entryChoices?: EntryChoice[];
  startImmediately?: boolean;
  // Create: pax, birthdates and rooms of the client folder the trip is for.
  seedComposition?: Parameters<typeof seedFromComposition>[0];
  // Create: start from the trip in the store (a template just opened). Edit
  // always starts from it.
  seedFromTrip?: boolean;
  onDone?: () => void;
  onExit?: () => void;
}

// The conversational trip form, create or edit, shared by both apps.
export function DesignTripWizard({
  mode = 'create',
  editId,
  entryChoices,
  startImmediately,
  seedComposition,
  seedFromTrip = mode === 'edit',
  onDone,
  onExit,
}: DesignTripWizardProps) {
  const { config, initialValues, tripId, fixedStepIds, blocked } =
    useDesignTripForm({
      mode,
      seedComposition,
      seedFromTrip,
      onDone,
      onExit,
    });

  if (blocked) return <>{blocked}</>;

  return (
    <TripDesignerWizard
      mode={mode}
      config={config}
      initialValues={initialValues}
      editId={mode === 'edit' ? (editId ?? tripId) : undefined}
      entryChoices={entryChoices}
      startImmediately={startImmediately}
      fixedStepIds={fixedStepIds}
    />
  );
}

export default DesignTripWizard;
